





















































































































































































































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "@/lib/ajax";
import RegionSelect from "@/components/region-select.vue";
import Order from "@/store/entities/booking/order";
import OrderDetail from "./components/order-detail.vue";
import TabsHeader from "@/components/tabs-header.vue";
import moment from "moment";
import UpdateTravel from "@/components/update-travel.vue";
import OrderTravelDate from "@/components/OrderTravelDate.vue";
import appConsts from "@/lib/appconst";
import CreateOrder from "./components/create-order.vue";
import appconst from "@/lib/appconst";
import EditOrder from "./components/edit-order.vue";
import User from "@/store/entities/user";
import ajax from "@/lib/ajax";
class PageOrderRequest extends PageRequest {
  orderType: number = null;
  orderNum: string;
  startDate: Date = null;
  endDate: Date = null;
  orderState: number = null;
  phoneNumber: number = null;
  sourceType: number = null;
  orderSource: number = 1;
  courtName: string = "";
  personNameOrLinkMan: string | null = null;
  creatorUserId: number | null = null;
  isHasAdminRemark: boolean | null = null;
}

@Component({
  components: {
    RegionSelect,
    OrderDetail,
    TabsHeader,
    UpdateTravel,
    OrderTravelDate,
    CreateOrder,
    EditOrder,
  },
})
export default class Orders extends AbpBase {
  //filters
  pagerequest: PageOrderRequest = new PageOrderRequest();
  courtList: any = [];
  supplierList: Array<any> = [];
  orderDetail: Order = new Order();
  seletedList: Array<number> = [];
  showOrderDetailModal = false;
  showUpdateTravel: boolean = false;
  showUpdateDateModel: boolean = false;
  editIndex: number = -1;
  editOrderState: number = -1;
  orderId: number = 0;
  editPriceIndex: number = -1;
  isUpdateShow: boolean = false;
  price: any = "";
  showCreateOrder: boolean = false;
  showEditOrder: boolean = false;
  adminList: Array<User> = [];
  hasAdminRemarkList: Array<object> = [
    {
      label: "是",
      value: 'true',
    },
    {
      label: "否",
      value: 'false',
    },
  ];
  payTypeList: Array<Object> = [
    {
      label: "未支付",
      value: 0,
    },
    {
      label: "支付完成",
      value: 1,
    },
  ];
  sourceTypeList: Array<object> = [
    {
      value: 0,
      label: "小程序",
    },
    {
      value: 1,
      label: "Pc",
    },
    {
      value: 2,
      label: "App",
    },
    {
      value: 3,
      label: "H5",
    },
  ];
  orderSources: Array<object> = [
    {
      value: 0,
      label: "线上",
    },
    {
      value: 1,
      label: "线下",
    },
  ];
  openEdit(row, index) {
    this.orderId = row.id;
    this.showEditOrder = true;
  }

  handleEdit(row, index) {
    this.editOrderState = row.orderState;
    this.editIndex = index;
  }
  async add() {
    this.showCreateOrder = true;
  }
  async handCancelAll() {
    this.seletedList = [];
  }
  async openTravelModel(id) {
    if (id) {
      this.orderId = id;
      this.showUpdateTravel = true;
    }
  }
  changeOrderType() {
    this.pagerequest.startDate = null;
    this.pagerequest.endDate = null;
  }
  async getAdmins() {
    let res = await ajax.get("/api/services/app/User/GetAll", {
      params: {
        isAdmin: true,
        skipCount: 0,
        maxResultCount: 10000,
      },
    });
    this.adminList = res.data.result.items;
  }
  async exportOrder() {
    try {
      let res = await this.$store.dispatch({
        type: "order/exportOrder",
        data: this.pagerequest,
      });
      if (res && res.data && res.data.result) {
        let url = `${appconst.excelDownloadUrl}${res.data.result}`;
        window.open(url, "_blank");
      }
    } catch (error) {
      console.error("导出 Excel 失败:", error);
    }
  }
  rowClick(order) {
    this.showDetail(order);
  }
  menuClick(name, row, index) {
    switch (name) {
      case "save":
        this.handleSave(row, index);
        break;
      case "cancel":
        this.editIndex = -1;
        break;
      case "detail":
        this.showDetail(row);
        break;
      case "updateOrderState":
        this.handleEdit(row, index);
        break;
      case "updateOrder":
        this.openEdit(row, index);
        break;
      // case "send":
      //   this.sendToUser(row.id);
      //   break;
      case "createPayUrl":
        this.orderDetail = row;
        this.createPayUrl(row.id);
        break;
      case "updatePrice":
        this.editPriceIndex = index;
        this.isUpdateShow = !this.isUpdateShow;
        if (!this.isUpdateShow) {
          this.updatePrice(row.id);
        }
        break;
      case "sendSmsToUserPay":
        this.sendSmsToUserPay(row.id);
        break;
      case "updateDate":
        this.openUpdateDateModel(row.id);
        break;
      default:
        break;
    }
  }
  async openUpdateDateModel(orderId) {
    this.orderId = orderId;
    this.showUpdateDateModel = true;
  }
  /**
   * @description:生成支付链接
   */
  createPayUrl(orderId) {
    console.log(this.orderDetail, "orderDetail");
    const url = `${appConsts.h5PayUrl}${orderId}`;
    const content = `${this.orderDetail.name}
${moment(this.orderDetail.teeTime).format(
  "YYYY-MM-DD HH:mm:ss"
)} (${this.getWeekName(this.orderDetail.teeTime)})
${this.orderDetail.personNames} ${this.orderDetail.personCount}位

需支付: ${this.orderDetail.weixinPay}元

支付链接: ${url}`;
    const contentCopy = `
        <div style="font-size: 16px; text-align: left;">
            <p>${this.orderDetail.name}</p>
            <p>${moment(this.orderDetail.teeTime).format(
              "YYYY-MM-DD HH:mm:ss"
            )} (${this.getWeekName(this.orderDetail.teeTime)})</p>
            <p>${this.orderDetail.personNames} ${
      this.orderDetail.personCount
    }位</p>
            <p>&nbsp;</p>
            <p>需支付: ${this.orderDetail.weixinPay}元</p>
            <p>&nbsp;</p>
            <p>支付链接: <a href="${url}" target="_blank">${url}</a></p>
        </div>
    `;

    this.$Modal.success({
      title: "支付链接",
      content: contentCopy,
      okText: "复制",
      width: 750,
      onOk: async () => {
        try {
          await (navigator as any).clipboard.writeText(content);
          this.$Message.success("复制成功");
        } catch (err) {
          this.$Message.error("复制失败");
        }
      },
    });
  }
  getWeekName(date) {
    // 参数时间戳
    let week = moment(date).day();
    switch (week) {
      case 1:
        return "周一";
      case 2:
        return "周二";
      case 3:
        return "周三";
      case 4:
        return "周四";
      case 5:
        return "周五";
      case 6:
        return "周六";
      case 0:
        return "周日";
    }
  }
  async sendSmsToUserPay(id) {
    this.$store
      .dispatch({
        type: "order/sendSmsToUserPay",
        id: id,
      })
      .then((res) => {
        this.$Message.success({
          content: "发送短信成功",
        });
      });
  }
  /**
   * @description:修改旅游打球价格
   */
  async updatePrice(id) {
    await Ajax.put("/api/services/app/Order/UpdatePayPrice", {
      id,
      price: this.price,
    });
    this.$Message.success({
      content: "修改旅游打球价格成功",
    });
    await this.getpage();
  }
  async handleSave(row, index) {
    await Ajax.put("/api/services/app/Order/UpdateOrderState", {
      id: row.id,
      orderState: this.editOrderState,
    });
    row.orderState = this.editOrderState;
    this.editIndex = -1;
    this.editOrderState = -1;
    await this.getpage();
  }

  // 显示订单详情
  showDetail(order) {
    this.orderDetail = order;
    this.showOrderDetailModal = true;
  }
  pageChange(page: number) {
    this.$store.commit("order/setOfflineCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("order/setOfflinePageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("order/setOfflineCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.orderSource = 1;
    //filters
    await this.$store.dispatch({
      type: "order/getOfflineAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.order.pageSize;
  }
  get totalCount() {
    return this.$store.state.order.offlineTotalCount;
  }
  get currentPage() {
    return this.$store.state.order.offlineCurrentPage;
  }
  get orderTypeList() {
    return this.$store.state.common.orderTypes;
  }

  get orderTypeDic() {
    return this.$store.state.common.orderTypesDic;
  }
  get headTypes() {
    return this.$store.state.common.headTypes;
  }
  get orderStates() {
    return this.$store.state.common.orderStates;
  }
  get orderStatesDic() {
    return this.$store.state.common.orderStatesDic;
  }
  get list() {
    const list = this.$store.state.order.offlineOrderList;
    list.forEach((e) => {
      if (e && e.orderState != 1) {
        e["_disabled"] = true;
      }
    });
    return list;
  }
  get loading() {
    return this.$store.state.order.offlineLoading;
  }
  getType(type) {
    if (type == 0) {
      return "球场预定";
    } else if (type == 1) {
      return "套餐预定";
    } else if (type == 2) {
      return "二手物品";
    } else if (type == 3) {
      return "套票会籍";
    } else if (type == 4) {
      return "团购订单";
    }
  }
  getSourceType(type) {
    if (type == 0) {
      return "小程序";
    } else if (type == 1) {
      return "Pc";
    } else if (type == 2) {
      return "App";
    } else if (type == 3) {
      return "H5";
    } else if (type == 4) {
      return "其他";
    }
  }
  columns = [
    {
      title: this.L("CourtName"),
      key: "name",
      tooltip: false,
    },
    {
      title: this.L("PlayDate"),
      key: "teeTime",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.teeTime).toLocaleDateString());
      },
    },

    {
      title: "打球人员",
      key: "personNames",
    },
    {
      title: "人数",
      key: "personCount",
      width: 40,
    },
    {
      title: "付款方",
      width: 80,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.supplier && params.row.supplier.name
            ? params.row.supplier.name
            : "暂无"
        );
      },
    },
    {
      title: "付款金额",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", params.row.supplierPayAmount);
      },
    },
    {
      title: "付款打款状态",
      width: 90,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.supplierPayType == 0 ? "未支付" : "支付完成"
        );
      },
    },
    {
      title: "收款方",
      width: 80,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.payee && params.row.payee.name
            ? params.row.payee.name
            : "暂无"
        );
      },
    },
    {
      title: "收款金额",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", params.row.payeeAmount);
      },
    },
    {
      title: "收款打款状态",
      width: 80,
      render: (h: any, params: any) => {
        return h("span", params.row.payeeType == 0 ? "未支付" : "支付完成");
      },
    },

    {
      title: this.L("OrderType"),
      key: "orderType",
      width: 60,
      render: (h: any, params: any) => {
        return h("span", this.getType(params.row.orderType));
      },
    },
    {
      title: "是/否备注",
      key: "adminRemark",
      width: 50,
      align: "center",
      render: (h: any, params: any) => {
        return h("span", params.row.adminRemark ? "是" : "否");
      },
    },
    {
      title: "订单日期",
      key: "creationTime",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          moment(params.row.creationTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("OrderState"),
      slot: "orderState",
      width: 80,
    },
    {
      title: this.L("Actions"),
      slot: "action",
      width: 70,
      align: "center",
    },
  ];
  async getCourtList(name?: String) {
    let params = {};
    if (name && name.length > 0) {
      params["name"] = name;
    }
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames", {
      params,
    });
    this.courtList = reponse.data.result;
  }
  /**
   * @description:获取供应商列表
   */
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  async created() {
    this.getpage();
    this.getCourtList();
    this.getSupplierList();
    if (this.hasPermission("Pages.Users.AdminList")) {
      this.getAdmins();
    }
  }
}
